import React, { useContext, useEffect } from 'react';

import {
    Paper,
    Avatar,
    Badge,
    Tooltip,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Link,
    colors
} from '@material-ui/core';

import {
    ConfirmIconButton
} from '../../../../common';

import { PageContext } from '../PageContext';

import { ApplicationRoles } from '../../../../../helpers';

import PersonIcon from '@material-ui/icons/PersonOutlined';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden'
    },
    table: {

    },
    user: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    disabled: {
        color: colors.grey[500]
    }
}));

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: 8        
    },
}))(Badge);

export const UserList = ({
    disabled,
    onViewUser,
    onRemoveUser,
    onToggleRole,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        table
    } = state;

    const {
        roles,
        users
    } = table;

    const viewUserClickHandler = (user) => {
        if (onViewUser) onViewUser(user);
    }

    const removeUserClickHandler = (user) => {
        if (onRemoveUser) onRemoveUser(user);
    }

    const toggleRoleClickHandler = (user, role) => {
        if (onToggleRole) onToggleRole(user, role);
    }

    return (
        <Paper className={classes.root}>
            <Table className={classes.table} arial-label="users list">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "70%" }}>Managing Users</TableCell>
                        {roles && roles.map(
                            (role, index) =>
                                <TableCell key={index} style={{ width: "10%" }} align="center">
                                    {role.roleName}
                                </TableCell>
                        )}
                        <TableCell style={{ width: "10%" }} align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell component="th" scope="row">
                                <div className={classes.user}>
                                    {user.isAdministrator ?
                                        <StyledBadge color="primary" variant="dot">
                                            <Tooltip title="Administrator">
                                                <Avatar aria-label="avatar" className={classes.avatar}>
                                                    <PersonIcon />
                                                </Avatar>
                                            </Tooltip>
                                        </StyledBadge>
                                        :
                                        <Avatar aria-label="avatar" className={classes.avatar}>
                                            <PersonIcon />
                                        </Avatar>

                                    }
                                    <Link
                                        className={disabled ? classes.disabled : null}
                                        component="button"
                                        color={"textSecondary"}
                                        disabled={disabled}
                                        onClick={() => viewUserClickHandler(user)}>
                                        <Typography>
                                            {user.displayName}
                                        </Typography>
                                    </Link>
                                </div>
                            </TableCell>
                            {roles && roles.map(
                                (role, index) => {
                                    const hasRole = user.isAdministrator || user.roleIds.find(x => x === role.roleId) !== undefined;
                                    return (
                                        <TableCell key={index} align="center">
                                            <ConfirmIconButton
                                                icon={hasRole ? <CheckBoxIcon /> : <CheckBoxBlankIcon />}
                                                tooltip={hasRole ? user.isAdministrator ? "Administrator has full access" : "Revoke" : "Assign"}
                                                confirmTooltip={hasRole ? "Confirm revoke" : "Confirm assign"}
                                                cancelTooltip={hasRole ? "Cancel revoke" : "Cancel assign"}
                                                disabled={disabled || user.isAdministrator}
                                                onClick={() => toggleRoleClickHandler(user, role)}
                                            />
                                        </TableCell>
                                    );
                                }
                            )}
                            <TableCell align="right">
                                {!user.isAdministrator &&
                                    <ConfirmIconButton
                                        dangerous
                                        icon={<NotInterestedIcon />}
                                        tooltip="Revoke user permissions"
                                        disabled={disabled}
                                        onClick={() => removeUserClickHandler(user)}
                                    />
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );
}